import axios from "axios";

const instance = axios.create({
	baseURL: "https://sushizoom-api.ithinkers.fun/api",
});

export const sushizoomAPI = {
	getCities() {
		return instance
			.get(`/cities`)
			.then((response) => {
				const data = response.data;
				console.log("data **** ", data);
				return data;
			})
			.catch((err) => console.log("err", err));
	},
};
